import type { ReactNode } from "react";
import { useFeatureFlag } from "../hooks/useFeatureFlag";
import type { FeatureFlagKey } from "../api/types";
import { FeatureDisabledPage } from "./FeatureDisabledPage";

interface Props {
  feature: FeatureFlagKey;
  children: ReactNode;
}

/**
 * Route wrapper that renders the children only if the per-business feature
 * flag is enabled. Otherwise renders `FeatureDisabledPage` with a link to
 * Settings → Business → General → Features.
 */
export function FeatureGate({ feature, children }: Props) {
  const enabled = useFeatureFlag(feature);
  if (!enabled) return <FeatureDisabledPage featureKey={feature} />;
  return <>{children}</>;
}
